import { toast } from "sonner";
import { formatApiError } from "./api";

// 402 = plan limit reached → friendly prompt with an Upgrade button.
export function toastApiError(e) {
  const msg = formatApiError(e);
  if (e?.response?.status === 402) {
    toast.error(msg, { duration: 9000, action: { label: "Upgrade", onClick: () => window.location.assign("/dashboard/billing") } });
  } else toast.error(msg);
}
